module.exports = __webpack_public_path__ + "img/top-list-left3.fdf210fe.png";